// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

// ** Toast Imports
import { toast } from 'react-toastify';

// CREATE JOB
export const createJobScheduler = createAsyncThunk('jobSchedulerSlice/createJobScheduler', async (data) => {
    try {
        const response = await axios.post('/scheduler', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
toast.success(response?.data?.message ||"Job Scheduler created successfully");
        return response.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        throw err;
    }
});

// GET ALL JOBS
export const getJobScheduler = createAsyncThunk('jobSchedulerSlice/getJobScheduler', async () => {
    try {
        const response = await axios.get('/scheduler', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (err) {
        console.log('err', err);

        toast.error(err?.response?.data?.message || 'Something went wrong!');

        throw err;
    }
});

// REFRESH JOBS
export const refreshJobScheduler = createAsyncThunk('jobSchedulerSlice/getJobScheduler', async () => {
    try {
        const response = await axios.get('/scheduler/refresh', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (err) {
        console.log('err', err);

        toast.error(err?.response?.data?.message || 'Something went wrong!');

        throw err;
    }
});

// GET ONE Job
export const getJobSchedulerById = createAsyncThunk('jobSchedulerSlice/getJobSchedulerById', async (id) => {
    try {
        const response = await axios.get(`/scheduler/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        throw err;
    }
});

// Update Job
export const updateJobScheduler = createAsyncThunk('jobSchedulerSlice/updateJobScheduler', async ({ id, data }) => {
    try {
        const response = await axios.put(`/scheduler/${id}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message ||"Job Scheduler updated successfully");
        return response.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        throw err;
    }
});
// Delete Job
export const deleteJobScheduler = createAsyncThunk('jobSchedulerSlice/deleteJobScheduler', async (id) => {
    try {
        const response = await axios.delete(`/scheduler/${id}`);
        toast.success(response?.data?.message || 'Job Scheduler deleted successfully.');
        return id;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        throw err;
    }
});

// Update Job Status
export const updateJobSchedulerStatus = createAsyncThunk(
    'jobSchedulerSlice/updateJobSchedulerStatus', 
    async (id, { dispatch }) => {
        try {
            const response = await axios.put(`/scheduler/status/${id}`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            toast.success(response?.data?.message || 'Status updated successfully!');
            dispatch(getJobScheduler());
            
            return response.data;
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            console.log('err', err);
            throw err;
        }
    }
);

// SLICE
export const jobSchedulerSlice = createSlice({
    name: 'jobSchedulerSlice',

    initialState: {
        jobScheduler: [],
        jobSchedulerById: {},
        newJobData: []
    },

    extraReducers: (builder) => {
        builder.addCase(getJobScheduler.fulfilled, (state, action) => {
            state.jobScheduler = action.payload;
        });

        builder.addCase(getJobSchedulerById.fulfilled, (state, action) => {
            state.jobSchedulerById = action.payload;
        });

        builder.addCase(createJobScheduler.fulfilled, (state, action) => {
            state.newJobData = action.payload;
        });

        builder.addCase(updateJobScheduler.fulfilled, (state, action) => {
            const index = state.jobScheduler.findIndex((job) => job.id === action.payload.id);

            if (index !== -1) {
                state.jobScheduler[index] = action.payload;
            }
        });

        builder.addCase(deleteJobScheduler.fulfilled, (state, action) => {
            state.jobScheduler = state.jobScheduler.filter((job) => job.id !== action.payload);
        });
    }
});

export default jobSchedulerSlice.reducer;
